var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.ab3966564e6f63568ed6ccaa2801837d.svg#b';
                    var viewUrl = 'sprites.ab3966564e6f63568ed6ccaa2801837d.svg#view-b';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 392 91',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };